import { render, staticRenderFns } from "./my-garage-tab.vue?vue&type=template&id=01cd9dce&scoped=true&"
import script from "./my-garage-tab.vue?vue&type=script&lang=js&"
export * from "./my-garage-tab.vue?vue&type=script&lang=js&"
import style0 from "./my-garage-tab.vue?vue&type=style&index=0&id=01cd9dce&scoped=true&lang=css&"
import style1 from "./my-garage-tab.vue?vue&type=style&index=1&id=01cd9dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd9dce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VCol,VDialog,VRow,VTextField})
